import queryString from 'query-string';

export const getToken = (params: string): string => {
  const search = queryString.parse(params);
  const token = search.token ? search.token : '';
  return token as string;
};
